import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AppService} from 'src/app/app.service';
import {JsonCase} from 'src/model/dto';
import {ContentType, SeverityEnum, ToastMsg} from "../../../model/page";

@Component({
  selector: 'app-case-edit-dialog',
  templateUrl: './case-edit-dialog.component.html',
  styleUrls: ['./case-edit-dialog.component.scss']
})
export class CaseEditDialogComponent {
  @Input() case: JsonCase;
  @Output() save: EventEmitter<JsonCase> = new EventEmitter();
  @Output() cancel: EventEmitter<JsonCase> = new EventEmitter();
  isShow = false;
  currentCase: JsonCase = null;

  constructor(
    private appService: AppService,
    private msgService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
  }

  setShow(isShow: boolean): void {
    this.isShow = isShow;
    if (isShow) {
      this.currentCase = JSON.parse(JSON.stringify(this.case))
    }
  }

  onSave(): void {
    this.appService.setBlock(true);
    this.appService.postBody('data', 'updateCase', JSON.stringify(this.currentCase), ContentType.json).subscribe((res: JsonCase) => {
      this.appService.setBlock(false);
      this.msgService.add(new ToastMsg(SeverityEnum.success, 'Save succeed', ''));
      this.save.emit(res);
      this.isShow = false;
    });
  }

  onCancel(): void {
    this.cancel.emit(this.case);
    this.isShow = false;
  }
}
